module.exports = __webpack_public_path__ + "img/login-right-side2.ce7a1a8d.png";